import React, { useEffect, useState } from 'react';
import { motion, time } from 'framer-motion';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
    ArrowLeft, Save, FileText, ChevronDown, ChevronUp, Trash2, Printer, X,
    FileCheck, Anchor, Package, User, Ship, MapPin,
    Container, Calendar, Plus, ClipboardCheck, Eye,
    Weight
} from 'lucide-react';
import { toast } from 'sonner';
import { useDispatch, useSelector } from "react-redux";
import { showToast } from '@/redux/Toast/actions';
import { callLoader } from '@/redux/Loader/actions';
import { getReleaseOrderDetails, updateReleaseOrderDetails } from '@/redux/ImportBooking/actions';
import DateInputwithcal from '@/components/ui/DateInputwithcal';
import ReleaseOrderValidation from "@/validation/releaseOrderform.json"
import { validateForm } from '@/components/ui/useFormValidation';
import { SearchBarPagination } from '@/components/SearchBox/SearchBarPagination';
import { getAddressAPI } from '@/redux/Purchase/actions';
import { SearchBar } from '@/components/SearchBox/SearchBar';
import DateTimeInputwithcal from '@/components/ui/DateTimeInputwithcal';
import PageHeader from '@/components/FormHeader/formPageHeader';

const initialState = {
    id: 0,
    bolId: 0,
    companyId: 0,

    releaseOrderDate: null,
    mawbNumber: '',
    hawbNumber: '',
    subBLNumber: '',
    amsBLNumber: '',

    eta: null,
    etd: null,
    etaAtDestination: null,

    vessel: '',
    vesselId: 0,
    voyage: '',

    itNumber: '',
    itPort: '',
    itDate: null,

    fromLocation: '',
    fromLocationId: 0,
    fromLocationAddress: '',

    releaseTo: '',
    releaseToId: 0,
    releaseToAddress: '',

    portOfLoading: '',
    portOfDischarge: '',
    finalDestination: '',

    portOfLoadingCode: '',
    portOfDischargeCode: '',

    shipper: '',
    shipperId: 0,
    shipperAddress: '',

    natureOfGoods: '',
    cargoDescription: '',

    carrier: '',
    carrierId: null,
    CarrierSCAC: '',

    specialInstructions: '',

    weightPrintOption: 'b',
    slac: true,
    doNotAutoCalculate: false,

    totalContainer: 0,
    totalPackage: 0,
    totalKgs: '',
    totalLbs: '',
    totalCbm: '',
    totalCft: '',
    totalNetKgs: '',
    totalNetLbs: '',

    isAcceptedRo: false,
    isAcceptedRoOn: null,
    isAcceptedRoBy: '',
    isAcceptedRoRemarks: '',

    isRejectedRo: false,
    isRejectedRoOn: null,
    isRejectedRoBy: '',
    isRejectedRoRemarks: '',

    isActive: true,
    isDeleted: false,

    releaseOrderDescriptions: [
        {
            id: Date.now(),
            containerNumber: '',
            sealNumber: '',
            marksNo: '',
            contTypeCode: '',
            contTypeName: '',
            noPackage: 0,
            packageCode: '',
            packageDescription: '',
            itNumber: '',
            cncprsNumber: '',
            pickupNumber: '',
            lastDate: null,
            kgs: 0,
            lbs: 0,
            cbm: 0,
            cft: 0,
            netKgs: 0,
            netLbs: 0
        }
    ]
};



const ReleaseOrderForm = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    // const decode = (str) => {
    //     try {
    //         if (!str) return null;

    //         const binary = atob(str);
    //         const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    //         return new TextDecoder().decode(bytes);
    //     } catch {
    //         return null;
    //     }
    // };

    const idbooking = queryParams.get("bolid");
    const fileRefNumber = queryParams.get("file_ref_no");
    console.log("fileRefNumber", fileRefNumber)

    const isEditMode = !!idbooking && idbooking !== 'new';
    const dispatch = useDispatch();

    const { containerTypeList } = useSelector((state) => state.common);

    const [authUser] = JSON.parse(localStorage.getItem('authUser') ?? "[{}]");

    const authCompanyId = authUser?.companyId;

    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [loadError, setLoadError] = useState(false);
    const [formData, setFormData] = useState(initialState);
    console.log("formDAta", formData)

    const [containers, setContainers] = useState([
        {
            id: 0,
            containerNumber: '',
            sealNumber: '',
            marksNo: '',
            contTypeCode: '',
            contTypeName: '',
            noPackage: 0,
            packageCode: '',
            packageDescription: '',
            itNumber: '',
            cncprsNumber: '',
            pickupNumber: '',
            lastDate: '',
            kgs: 0,
            lbs: 0,
            cbm: 0,
            cft: 0,
            netKgs: 0,
            netLbs: 0,
            isDelete: false,
        }

        //    {
        //         containerNo: '', sealNo: '', marksNo: '', contType: '', noPackage: '',
        //         cargoDescription: '', itNo: '', cnCprs: '', pickupNo: '',
        //         lastFreeDay: '', netWeightKgs: '0', netWeightLbs: '0',
        //         grossWeightKgs: '0', grossWeightLbs: '0',
        //         measurementCbm: '0.000', measurementCft: '0.000'
        //     }
    ]);
    console.log("containers", containers)

    const [expandedSections, setExpandedSections] = useState({
        fileInfo: true,
        particulars: true,
    });

    const [dateErrors, setDateErrors] = useState({});
    const [errors, setErrors] = useState({});


    const toggleSection = (section) => {
        setExpandedSections(prev => ({ ...prev, [section]: !prev[section] }));
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const handleContainerChange = (index, field, value) => {
        setContainers(prev => prev.map((c, i) => i === index ? { ...c, [field]: value } : c));
    };

    const addContainer = () => {
        setContainers(prev => [...prev, {
            id: 0,
            tempId: Date.now(),
            containerNumber: '',
            sealNumber: '',
            marksNo: '',
            contTypeCode: '',
            contTypeName: '',
            noPackage: 0,
            packageCode: '',
            packageDescription: '',
            itNumber: '',
            cncprsNumber: '',
            pickupNumber: '',
            lastDate: null,
            kgs: 0,
            lbs: 0,
            cbm: 0,
            cft: 0,
            netKgs: 0,
            netLbs: 0,
            isDeleted: false,
        }]);
    };

    // const removeContainer = (index) => {
    //     if (containers.length > 1) setContainers(prev => prev.filter((_, i) => i !== index));
    // };


    const removeContainer = (itemToRemove) => {
        setContainers(prev =>
            prev.map(item =>
                (item.id > 0 && item.id === itemToRemove.id) ||
                    (item.id === 0 && item.tempId === itemToRemove.tempId)
                    ? { ...item, isDeleted: true }
                    : item
            )
        );
    };



    // {📅📅📅📅📅 date formData handlers YYYY-MM-DD}
    const handleDateChange = (name, value) => {
        setFormData((prev) => ({
            ...prev,
            [name]: value ? value : null, // store null if blank
        }));
    };

    const handleDateError = (fieldName, hasError) => {
        setDateErrors(prev => ({
            ...prev,
            [fieldName]: hasError
        }));
    };

    const toISOorNull = (val) => {
        if (!val) return null;
        const d = new Date(val);
        return isNaN(d.getTime()) ? null : d.toISOString();
    };

    const toNumber = (val) => Number(val) || 0;
    const toString = (val) => val ?? "";


    const positiveId = (val) => {
        const n = Number(val);
        return Number.isFinite(n) && n > 0 ? n : null;
    };

    const effectiveBolId = (formBolId) =>
        positiveId(formBolId) ?? positiveId(idbooking);

    const effectiveCompanyId = (formCompanyId) =>
        positiveId(formCompanyId) ?? positiveId(authCompanyId);

    const mapFormToApi = (data, containers) => {
        const resolvedBolId = effectiveBolId(data.bolId);
        const resolvedCompanyId = effectiveCompanyId(data.companyId);

        return {
            id: toNumber(data.id),

            ...(resolvedBolId !== null && { bolId: resolvedBolId }),

            ...(resolvedCompanyId !== null && { compnayId: resolvedCompanyId }),

            releaseOrderNumber: toString(data.releaseOrderNumber),

            releaseOrderDate: toISOorNull(data.releaseOrderDate),

            mawbNumber: toString(data.mawbNumber),
            hawbNumber: toString(data.hawbNumber),
            subBLNumber: toString(data.subBLNumber),

            amsBLNumber: toString(data.amsBLNumber),

            eta: toISOorNull(data.eta),
            etd: toISOorNull(data.etd),
            etaAtDestination: toISOorNull(data.etaAtDestination),

            vessel: toString(data.vessel),
            vesselId: toNumber(data.vesselId),
            voyage: toString(data.voyage),

            cargoDescription: toString(data.cargoDescription),

            itNumber: toString(data.itNumber),
            itPort: toString(data.itPort),
            itDate: toISOorNull(data.itDate),

            fromLocation: toString(data.fromLocation),
            fromLocationId: toNumber(data.fromLocationId),
            fromLocationAddress: toString(data.fromLocationAddress),

            releaseTo: toString(data.releaseTo),
            releaseToId: toNumber(data.releaseToId),
            releaseToAddress: toString(data.releaseToAddress),

            portOfLoading: toString(data.portOfLoading),
            portOfDischarge: toString(data.portOfDischarge),
            finalDestination: toString(data.finalDestination),

            shipper: toString(data.shipper),
            natureOfGoods: toString(data.natureOfGoods),

            carrier: toString(data.carrier),
            carrierId: toNumber(data.carrierId),

            specialInstructions: toString(data.specialInstructions)?.trim(),

            weightPrintOption: data.weightPrintOption || "b",
            slac: !!data.slac,
            doNotAutoCalculate: !!data.doNotAutoCalculate,

            totalContainer: toNumber(data.totalContainer),
            totalPackage: toNumber(data.totalPackage),

            totalKgs: toString(data.totalKgs),
            totalLbs: toString(data.totalLbs),
            totalCbm: toString(data.totalCbm),
            totalCft: toString(data.totalCft),
            totalNetKgs: String(data.totalNetKgs || ""),
            totalNetLbs: String(data.totalNetLbs || ""),


            isAcceptedRo: !!data.isAcceptedRo,
            isAcceptedRoOn: toISOorNull(data.isAcceptedRoOn),
            isAcceptedRoBy: toString(data.isAcceptedRoBy),
            isAcceptedRoRemarks: toString(data.isAcceptedRoRemarks),

            isRejectedRo: !!data.isRejectedRo,
            isRejectedRoOn: toISOorNull(data.isRejectedRoOn),
            isRejectedRoBy: toString(data.isRejectedRoBy),
            isRejectedRoRemarks: toString(data.isRejectedRoRemarks),

            isActive: !!data.isActive,
            isDeleted: !!data.isDeleted,

            createdBy: toString(data.createdBy) || "admin",
            createdOn: toISOorNull(data.createdOn),
            modifiedBy: toString(data.modifiedBy),
            modifiedOn: toISOorNull(data.modifiedOn),

            releaseOrderDescriptions: (containers || [])
                .filter(item =>
                    item.containerNumber ||
                    item.sealNumber ||
                    item.marksNo
                )
                .map(item => ({
                    id: item.id > 1000000000000 ? 0 : toNumber(item.id),

                    containerNumber: toString(item.containerNumber),
                    sealNumber: toString(item.sealNumber),
                    marksNo: toString(item.marksNo),
                    contTypeCode: toString(item.contTypeCode),
                    contTypeName: toString(item.contTypeName),

                    noPackage: toNumber(item.noPackage),

                    packageCode: toString(item.packageCode),
                    packageDescription: toString(item.packageDescription),

                    itNumber: toString(item.itNumber),
                    cncprsNumber: toString(item.cncprsNumber),

                    pickupNumber: toString(item.pickupNumber),

                    lastDate: toISOorNull(item.lastDate),

                    kgs: toNumber(item.kgs),
                    lbs: toNumber(item.lbs),
                    cbm: toNumber(item.cbm),
                    cft: toNumber(item.cft),
                    netKgs: toNumber(item.netKgs),
                    netLbs: toNumber(item.netLbs),
                    isDeleted: item.isDeleted,


                    releaseOrderId: toNumber(data.id),
                    ...(resolvedCompanyId !== null && { companyId: resolvedCompanyId }),
                    ...(resolvedBolId !== null && { bolId: resolvedBolId }),
                }))
        };
    };

    // {📅📅📅📅📅 end date formData handlers}
    const handleSubmit = async (e) => {
        e?.preventDefault?.();

        console.log("handleSubmit form", formData);

        // ✅ Prevent submit if edit data failed to load
        if (isEditMode && (!isDataLoaded || loadError)) {
            dispatch(
                showToast(
                    "Release Order data not loaded properly",
                    "error"
                )
            );
            return;
        }

        const validationErrors = validateForm({
            data: formData,
            rules: ReleaseOrderValidation,
        });

        setErrors(validationErrors);

        const hasDateErrors = Object.values(
            dateErrors || {}
        ).some(Boolean);

        if (
            Object.keys(validationErrors).length > 0 ||
            hasDateErrors
        ) {
            return;
        }

        const submitBolId = effectiveBolId(formData.bolId);
        const submitCompanyId = effectiveCompanyId(formData.companyId);
        if (submitBolId === null || submitCompanyId === null) {
            dispatch(
                showToast(
                    "Valid Booking ID and company are required to save the release order.",
                    "error"
                )
            );
            return;
        }

        try {
            dispatch(callLoader(1));

            // ✅ Prepare payload
            const payload = mapFormToApi(
                formData,
                containers
            );

            console.log("FINAL PAYLOAD", payload);

            const response = await dispatch(
                updateReleaseOrderDetails(payload)
            );

            console.log("API RESPONSE", response);

            const isSuccess = [200, 201].includes(
                response?.statuscode
            );

            if (!isSuccess) {
                throw new Error(
                    response?.message ||
                    "Error while saving Release Order"
                );
            }

            dispatch(
                showToast(
                    isEditMode
                        ? "Release Order updated successfully!"
                        : "Release Order created successfully!",
                    "success",
                    true
                )
            );


            return {
                success: true,
                status: response.statuscode,
                data: response,
            };

        } catch (error) {
            console.error(
                "SUBMIT RELEASE ORDER ERROR:",
                error
            );

            const errorMessage =
                error?.response?.data?.title ||
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong";

            dispatch(
                showToast(errorMessage, "error")
            );

            return {
                success: false,
                status:
                    error?.response?.status ||
                    error?.statuscode ||
                    500,
                errors:
                    error?.response?.data?.errors || null,
            };

        } finally {
            dispatch(callLoader(0));
        }
    };

    const handleChange = (e) => {
        if (typeof onChange === "function") {
            return onChange(e);
        }
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const _getPortCode = (strdata) => {
        if (!strdata) return "";
        const match = strdata.match(/\[(.*?)\]/);
        const code = match ? match[1] : "";
        console.log(code); // INBOM
        return code;
    }

    const _setAddress = async (type, id) => {
        const address = await getAddressAPI(id);
        setFormData(prev => ({ ...prev, [`${type}`]: address }));
    };


    const _getReleaseOrderData = async () => {
        const fetchBolId = positiveId(idbooking);
        const fetchCompanyId = positiveId(authCompanyId);
        if (fetchBolId === null || fetchCompanyId === null) {
            setLoadError(true);
            setIsDataLoaded(false);
            dispatch(
                showToast(
                    fetchBolId === null
                        ? "Invalid or missing booking ID for this release order."
                        : "Company ID is missing. Please sign in again.",
                    "error"
                )
            );
            return;
        }

        try {
            dispatch(callLoader(1));

            setLoadError(false);
            setIsDataLoaded(false);

            const resultData = await dispatch(
                getReleaseOrderDetails(
                    fetchBolId,
                    fetchCompanyId
                )
            );

            console.log("release order data api", resultData);

            if (
                !resultData ||
                typeof resultData !== "object"
            ) {
                throw new Error("Invalid release order data");
            }

            const {
                releaseOrderDescriptions = [],
                ...lightData
            } = resultData;

            setFormData(prev => {
                const merged = { ...prev, ...lightData };
                return {
                    ...merged,
                    bolId: effectiveBolId(merged.bolId),
                    companyId: effectiveCompanyId(merged.companyId),
                };
            });

            setContainers(releaseOrderDescriptions);

            setIsDataLoaded(true);

        } catch (error) {
            console.error("GET RELEASE ORDER ERROR:", error);

            setLoadError(true);

            dispatch(
                showToast(
                    error?.message ||
                    "Failed to load Release Order details",
                    "error"
                )
            );
        } finally {
            dispatch(callLoader(0));
        }
    };

    useEffect(() => {
        if (idbooking && idbooking !== "new") {
            _getReleaseOrderData();
        }
    }, [idbooking]);

    /** Keep bolId / companyId off 0 when URL or session has real IDs (production guard). */
    useEffect(() => {
        setFormData(prev => {
            const bol = effectiveBolId(prev.bolId);
            const co = effectiveCompanyId(prev.companyId);
            const patch = {};
            if (bol !== null && positiveId(prev.bolId) === null) {
                patch.bolId = bol;
            }
            if (co !== null && positiveId(prev.companyId) === null) {
                patch.companyId = co;
            }
            if (Object.keys(patch).length === 0) return prev;
            return { ...prev, ...patch };
        });
    }, [idbooking, authCompanyId]);




    // Totals
    // const totalContainers =  containers.filter(c => c.containerNo).length;
    const totalContainers = containers?.length || 0;
    const totalPackages = containers.reduce((sum, c) => sum + (parseInt(c.noPackage) || 0), 0);
    const totalNetWeightKgs = containers.reduce((sum, c) => sum + (parseFloat(c.netKgs) || 0), 0);
    const totalNetWeightLbs = containers.reduce((sum, c) => sum + (parseFloat(c.netLbs) || 0), 0);
    const totalGrossKgs = containers.reduce((sum, c) => sum + (parseFloat(c.kgs) || 0), 0);
    const totalGrossLbs = containers.reduce((sum, c) => sum + (parseFloat(c.lbs) || 0), 0);
    const totalCbm = containers.reduce((sum, c) => sum + (parseFloat(c.cbm) || 0), 0);
    const totalCft = containers.reduce((sum, c) => sum + (parseFloat(c.cft) || 0), 0);

    const inputClass = "w-full px-3 py-[0.6rem] bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-md text-sm text-slate-900 dark:text-white placeholder-slate-400 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all";
    const selectClass = "w-full px-3 py-[0.5rem] bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-md text-sm text-slate-900 dark:text-white focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all appearance-none cursor-pointer";

    const SectionHeader = ({ icon: Icon, title, color = "blue", section }) => (
        <button
            onClick={() => toggleSection(section)}
            className="w-full flex items-center justify-between p-4 bg-gradient-to-r to-slate-100 dark:from-slate-800 dark:to-slate-700 cursor-pointer"
        >
            <div className="flex items-center gap-3">
                <div className={`p-2 rounded-lg shadow-md ${color}`}>
                    <Icon className="w-4 h-4 text-white" />
                </div>
                <h2 className="text-sm font-semibold text-slate-900 dark:text-slate-200">{title}</h2>
            </div>
            <div className={`p-1.5 rounded-md transition-colors ${expandedSections[section] ? "bg-indigo-100 dark:bg-indigo-900/30"
                : "bg-slate-200 dark:bg-slate-700"}`}>
                {expandedSections[section] ? (
                    <ChevronUp className="w-4 h-4 text-indigo-600 dark:text-indigo-400" />
                ) : (
                    <ChevronDown className="w-4 h-4 text-slate-500 dark:text-slate-400" />
                )}
            </div>
        </button>
    );

    return (
        <div className="mx-auto p-2 sm:p-3 sticky top-0 bg-gradient-to-r">            {/* Header */}

            {/* Header */}
            <PageHeader
                icon={<FileCheck className="w-5 h-5 text-white" />}

                title="Release Order"

                badge={
                    formData?.houseBLNo
                        ? `BL: ${formData.houseBLNo}`
                        : isEditMode
                            ? "Editing Release Order"
                            : "New Release Order"
                }

                subtitle={
                    isEditMode
                        ? "Update release order details"
                        : "Create a new release order"
                }

                actions={[
                    {
                        label: "Back",
                        icon: <ArrowLeft />,
                        onClick: () => navigate("/import-booking"),
                        variant: "ghost",
                    },

                    {
                        label: "BL",
                        onClick: () => navigate(`/import-booking/edit/${formData?.bolId || idbooking}`),
                        variant: "tertiary",
                    },
                    {
                        label: "Status Audit",
                        onClick: () => navigate(`/import-booking/status-audit/${formData?.bolId || 0}?companyId=${authUser?.companyId}`, {
                            state: {
                                bookingId: formData?.BolID || idbooking,
                                companyId: authUser?.companyId,
                            }
                        }),
                        variant: "tertiary",
                    },
                    {
                        label: "New Release Order",
                        onClick: () => navigate("/release-order/new"),
                        variant: "tertiary",
                    },

                    "|",

                    {
                        label: "Print",
                        icon: <Printer />,
                        onClick: () =>
                            window.open(
                                `/release-order/print/${btoa(formData?.bolId)}?fileRefNumber=${fileRefNumber}`
                            ),
                        variant: "black",
                    },
                ]}
                submitLabel="Save"
                onSubmit={handleSubmit}
            />

            <div style={{ height: "var(--page-header-height)" }} />

            <form className="space-y-3" onSubmit={(e) => e.preventDefault()}>
                {/* File Information */}
                <div className="bg-white dark:bg-slate-900 rounded-lg shadow-sm border border-slate-200 dark:border-slate-800 overflow-hidden">
                    <SectionHeader icon={FileText} title="File Information" color="bg-blue-500" section="fileInfo" />

                    {expandedSections.fileInfo && (
                        <motion.div
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: 'auto', opacity: 1 }}
                            className="p-4 border-t border-slate-200 dark:border-slate-800"
                        >
                            <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
                                {/* Left Column */}
                                <div className="space-y-3">
                                    <div className="grid grid-cols-[140px_1fr] items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">
                                            Date <span className="text-red-500">*</span>
                                        </label>
                                        {/* <input type="date" name="date" value={formData.date} onChange={handleInputChange} className={inputClass} data-testid="field-date" /> */}
                                        <div>
                                            <DateInputwithcal onError={handleDateError} label="Date" name="releaseOrderDate" value={formData?.releaseOrderDate} onChange={handleDateChange} required />
                                            {errors.releaseOrderDate && (
                                                <p className="text-red-500 text-xs mt-1">{errors.releaseOrderDate}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-[140px_1fr] items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">
                                            Master B/L No. <span className="text-red-500">*</span>
                                        </label>
                                        <div>
                                            <input type="text" name="mawbNumber" value={formData?.mawbNumber} onChange={handleInputChange} className={inputClass} data-testid="field-master-bl" />
                                            {errors.mawbNumber && (
                                                <p className="text-red-500 text-xs mt-1">{errors.mawbNumber}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-[140px_1fr] items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">
                                            House B/L No. <span className="text-red-500">*</span>
                                        </label>
                                        <div>
                                            <input type="text" name="hawbNumber" value={formData?.hawbNumber} onChange={handleInputChange} className={inputClass} data-testid="field-house-bl" />
                                            {errors.hawbNumber && (
                                                <p className="text-red-500 text-xs mt-1">{errors.hawbNumber}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-[140px_1fr] items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Sub B/L No.</label>
                                        <input type="text" name="subBLNumber" value={formData.subBLNumber} onChange={handleInputChange} className={inputClass} data-testid="field-sub-bl" />
                                    </div>
                                    <div className="grid grid-cols-[140px_1fr] items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">AMS B/L No.</label>
                                        <input type="text" name="amsBLNumber" value={formData.amsBLNumber} onChange={handleInputChange} className={inputClass} data-testid="field-ams-bl" />
                                    </div>
                                    <div className="grid grid-cols-[140px_1fr] items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">
                                            Carrier <span className="text-red-500">*</span>
                                        </label>
                                        {/* <select name="carrier" value={formData.carrier} onChange={handleInputChange} className={selectClass} data-testid="field-carrier">
                                            <option value="">SELECT CARRIER</option>
                                            <option value="COSCO">COSCO</option>
                                            <option value="MSC">MSC</option>
                                            <option value="MAERSK">MAERSK</option>
                                            <option value="HAPAG-LLOYD">HAPAG-LLOYD</option>
                                            <option value="ONE">ONE</option>
                                            <option value="CMA CGM">CMA CGM</option>
                                            <option value="EVERGREEN">EVERGREEN</option>
                                            <option value="YANG MING">YANG MING</option>
                                        </select> */}
                                        <div>
                                            <SearchBarPagination
                                                searchAPI="v1/AutoSuggestion/GetCarrierSuggestion?Prefix="
                                                selectReacord={(d) => {
                                                    handleChange({ target: { name: 'carrier', value: d?.[1] } });
                                                    handleChange({ target: { name: 'carrierId', value: d?.[0] } });
                                                    handleChange({ target: { name: 'CarrierSCAC', value: String(d?.[2] ?? '') } });
                                                }}
                                                value={formData?.carrier || ''}
                                                placeholder="Select carrier"
                                                className="bg-white dark:bg-slate-900 border border-slate-700 rounded-lg text-sm text-white"
                                            />
                                            {errors.carrier && (
                                                <p className="text-red-500 text-xs mt-1">{errors.carrier}</p>
                                            )}
                                        </div>


                                    </div>
                                    <div className="grid grid-cols-[140px_1fr] items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">
                                            Port of Loading <span className="text-red-500">*</span>
                                        </label>
                                        {/* <input type="text" name="portOfLoading" value={formData?.portOfLoading} onChange={handleInputChange} className={inputClass} data-testid="field-pol" /> */}
                                        <div>
                                            <SearchBar
                                                searchAPI={'v1/AutoSuggestion/GetDestinationSuggestion?Prefix='}
                                                selectReacord={(d) => {
                                                    handleInputChange({ target: { name: 'portOfLoading', value: d?.[1] } })
                                                    handleInputChange({
                                                        target: {
                                                            name: 'portOfLoadingCode',
                                                            value: _getPortCode(d?.[1])
                                                        }
                                                    })
                                                }}
                                                value={formData?.portOfLoading}
                                                onchange={(val) => {
                                                    if (!val) {
                                                        handleInputChange({ target: { name: 'portOfLoading', value: '' } });
                                                        handleInputChange({ target: { name: 'portOfLoadingCode', value: '' } });
                                                    }
                                                }}
                                            />
                                            {errors.portOfLoading && (
                                                <p className="text-red-500 text-xs mt-1">{errors.portOfLoading}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-[140px_1fr] items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">
                                            Port of Discharge <span className="text-red-500">*</span>
                                        </label>
                                        {/* <input type="text" name="portOfDischarge" value={formData?.portOfDischarge} onChange={handleInputChange} className={inputClass} data-testid="field-pod" /> */}
                                        <div>
                                            <SearchBar
                                                searchAPI={'v1/AutoSuggestion/GetDestinationSuggestion?Prefix='}
                                                selectReacord={(d) => {
                                                    handleInputChange({ target: { name: 'portOfDischarge', value: d?.[1] } })
                                                    handleInputChange({ target: { name: 'portOfDischargeCode', value: _getPortCode(d?.[1]) } })
                                                }}
                                                value={formData?.portOfDischarge}
                                                onchange={(val) => {
                                                    if (!val) {
                                                        handleInputChange({ target: { name: 'portOfDischarge', value: '' } });
                                                        handleInputChange({ target: { name: 'portOfDischargeCode', value: '' } });
                                                    }
                                                }}
                                            />
                                            {errors.portOfDischarge && (
                                                <p className="text-red-500 text-xs mt-1">{errors.portOfDischarge}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-[140px_1fr] items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Final Destination</label>
                                        {/* <input type="text" name="finalDestination" value={formData?.finalDestination} onChange={handleInputChange} className={inputClass} data-testid="field-final-dest" /> */}
                                        <SearchBar
                                            searchAPI={'v1/AutoSuggestion/GetDestinationSuggestion?Prefix='}
                                            selectReacord={(d) => {
                                                handleInputChange({ target: { name: 'finalDestination', value: d?.[1] } })
                                            }}
                                            value={formData?.finalDestination}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({ target: { name: 'finalDestination', value: '' } });
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="grid grid-cols-[140px_1fr] items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">
                                            ETA <span className="text-red-500">*</span>
                                        </label>
                                        <div>
                                            <DateInputwithcal onError={handleDateError} label="ETA" name="eta" value={formData?.eta} onChange={handleDateChange} required />
                                            {errors.eta && (
                                                <p className="text-red-500 text-xs mt-1">{errors.eta}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-[140px_1fr] items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">
                                            ETD <span className="text-red-500">*</span>
                                        </label>
                                        <div>
                                            <DateInputwithcal onError={handleDateError} label="ETD" name="etd" value={formData?.etd} onChange={handleDateChange} required />
                                            {errors.etd && (
                                                <p className="text-red-500 text-xs mt-1">{errors.etd}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-[140px_1fr] items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">ETA at Destination</label>
                                        {/* <input type="date" name="etaAtDestination" value={formData.etaAtDestination} onChange={handleInputChange} className={inputClass} data-testid="field-eta-dest" /> */}
                                        <DateInputwithcal onError={handleDateError} label="ETA at Destination" name="etaAtDestination" value={formData?.etaAtDestination} onChange={handleDateChange} required />
                                    </div>
                                    <div className="grid grid-cols-[140px_1fr] items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">
                                            Vessel <span className="text-red-500">*</span>
                                        </label>
                                        {/* <input type="text" name="vessel" value={formData.vessel} onChange={handleInputChange} className={inputClass} data-testid="field-vessel" /> */}
                                        <div>
                                            <SearchBar
                                                searchAPI="v1/AutoSuggestion/GetVesselList?Prefix="
                                                selectReacord={(d) => {
                                                    handleInputChange({ target: { name: 'vessel', value: d?.[1] } });
                                                    handleInputChange({ target: { name: 'vesselCode', value: String(d?.[0] ?? '') } });
                                                }}
                                                value={formData?.vessel || ''}
                                                placeholder="Select vessel"
                                                className="bg-white dark:bg-slate-900 border border-slate-700 rounded-lg text-sm text-white"
                                            />
                                            {errors.vessel && (
                                                <p className="text-red-500 text-xs mt-1">{errors.vessel}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-[140px_1fr] items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">
                                            Voyage <span className="text-red-500">*</span>
                                        </label>
                                        <div>
                                            <input type="text" name="voyage" value={formData.voyage} onChange={handleInputChange} className={`${inputClass} w-24`} data-testid="field-voyage" />
                                            {errors.voyage && (
                                                <p className="text-red-500 text-xs mt-1">{errors.voyage}</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-[140px_1fr] items-start gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400 pt-2">Cargo Description</label>
                                        <textarea name="cargoDescription" value={formData.cargoDescription} onChange={handleInputChange} rows={2} className={`${inputClass} resize-none`} data-testid="field-cargo-desc" />
                                    </div>
                                </div>

                                {/* Right Column */}
                                <div className="space-y-3">
                                    {/* <div className="space-y-3 p-4 border border-slate-200 dark:border-slate-700 rounded-lg"> */}
                                    <div>
                                        <label className="text-xs font-semibold text-emerald-600 dark:text-emerald-400 mb-1 block">
                                            Cargo Pick Up Location
                                        </label>
                                        {/* <input type="text" name="fromLocation" value={formData?.fromLocation} onChange={handleInputChange} className={inputClass} data-testid="field-pickup-location" /> */}
                                        <SearchBar
                                            searchAPI={'v1/AutoSuggestion/GetTruckerAndTowing?Prefix='}
                                            selectReacord={(d) => {
                                                handleInputChange({ target: { name: 'fromLocation', value: d?.[1] } })
                                                handleInputChange({ target: { name: 'fromLocationId', value: d?.[0] } })
                                                _setAddress('fromLocationAddress', d?.[0]);
                                            }}
                                            value={formData?.fromLocation}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({ target: { name: 'fromLocation', value: '' } });
                                                    handleInputChange({ target: { name: 'fromLocationId', value: 0 } });
                                                }
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <label className="text-xs font-semibold text-red-500 mb-1 block">Address</label>
                                        <textarea name="fromLocationAddress" value={formData?.fromLocationAddress} onChange={handleInputChange} rows={3} className={`${inputClass} resize-none`} data-testid="field-pickup-address" />
                                    </div>

                                    <div className="pt-2 border-t border-slate-200 dark:border-slate-700">
                                        <label className="text-xs font-semibold text-emerald-600 dark:text-emerald-400 mb-1 block">
                                            Release To
                                        </label>
                                        {/* <input type="text" name="releaseTo" value={formData?.releaseTo} onChange={handleInputChange} className={inputClass} data-testid="field-release-to" /> */}
                                        <SearchBar
                                            searchAPI={'v1/AutoSuggestion/GetTruckerAndTowing?Prefix='}
                                            selectReacord={(d) => {
                                                handleInputChange({ target: { name: 'releaseTo', value: d?.[1] } })
                                                handleInputChange({ target: { name: 'releaseToId', value: d?.[0] } })
                                                _setAddress('releaseToAddress', d?.[0]);
                                            }}
                                            value={formData?.releaseTo}
                                            onchange={(val) => {
                                                if (!val) {
                                                    handleInputChange({ target: { name: 'releaseTo', value: '' } });
                                                    handleInputChange({ target: { name: 'releaseToId', value: 0 } });
                                                }
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <label className="text-xs font-semibold text-red-500 mb-1 block">Address</label>
                                        <textarea name="releaseToAddress" value={formData?.releaseToAddress} onChange={handleInputChange} rows={3} className={`${inputClass} resize-none`} data-testid="field-release-to-address" />
                                    </div>

                                    <div className="pt-2 border-t border-slate-200 dark:border-slate-700">
                                        <div className="grid grid-cols-[100px_1fr] items-center gap-2">
                                            <label className="text-xs font-medium text-slate-600 dark:text-slate-400">
                                                Shipper <span className="text-red-500">*</span>
                                            </label>
                                            <div>
                                                <SearchBar
                                                    searchAPI={'v1/AutoSuggestion/GetConsigneeSuggestion?Prefix='}
                                                    selectReacord={(d) => {
                                                        handleInputChange({ target: { name: 'shipper', value: d?.[1] } });
                                                        handleInputChange({ target: { name: 'shipperId', value: d?.[0] } });
                                                        _setAddress('shipperAddress', d?.[0]);
                                                    }}
                                                    value={formData?.shipper || ''}
                                                    onchange={(val) => {
                                                        if (!val) {
                                                            handleInputChange({ target: { name: 'shipper', value: '' } });
                                                            handleInputChange({ target: { name: 'shipperId', value: 0 } });
                                                        }
                                                    }}
                                                />
                                                {errors.shipper && (
                                                    <p className="text-red-500 text-xs mt-1">{errors.shipper}</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-[100px_1fr] items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">IT Number</label>
                                        <input type="text" name="itNumber" value={formData?.itNumber} onChange={handleInputChange} className={inputClass} data-testid="field-it-number" />
                                    </div>
                                    <div className="grid grid-cols-[100px_1fr] items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">IT Port</label>
                                        <input type="text" name="itPort" value={formData?.itPort} onChange={handleInputChange} className={inputClass} data-testid="field-it-port" />
                                    </div>
                                    <div className="grid grid-cols-[100px_1fr] items-center gap-2">
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400">IT Date</label>
                                        {/* <input type="date" name="itDate" value={formData.itDate} onChange={handleInputChange} className={inputClass} data-testid="field-it-date" /> */}
                                        <DateInputwithcal onError={handleDateError} label="IT Date" name="itDate" value={formData?.itDate} onChange={handleDateChange} required />
                                    </div>
                                    <div>
                                        <label className="text-xs font-medium text-slate-600 dark:text-slate-400 mb-1 block">Special Instructions</label>
                                        <textarea name="specialInstructions" value={formData.specialInstructions} onChange={handleInputChange} rows={4} className={`${inputClass} resize-none`} data-testid="field-special-instructions" />
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    )}
                </div>

                {/* Particulars Furnished by Shipper */}
                <div className="bg-white dark:bg-slate-900 rounded-lg shadow-sm border border-slate-200 dark:border-slate-800 overflow-hidden">
                    <SectionHeader icon={User} title="Particulars Furnished by Shipper" color="bg-blue-500" section="particulars" />

                    {expandedSections.particulars && (
                        <motion.div
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: 'auto', opacity: 1 }}
                            className="p-4 border-t border-slate-200 dark:border-slate-800"
                        >
                            {/* Options Row */}
                            <div className="flex flex-wrap items-center gap-6 mb-4 pb-4 border-b border-slate-200 dark:border-slate-700">
                                <span className="text-xs font-medium text-slate-600 dark:text-slate-400">Print Weight & Measurement on B/L</span>
                                <div className="flex items-center gap-4">
                                    {[
                                        { label: 'Both', value: 'b' },
                                        { label: 'Metric Only', value: 'm' },
                                        { label: 'English Only', value: 'e' }
                                    ].map((opt) => (
                                        <label key={opt.label} className="flex items-center gap-1.5 cursor-pointer">
                                            <input
                                                type="radio"
                                                name="weightPrintOption"
                                                value={opt.value}
                                                checked={formData.weightPrintOption === opt.value}
                                                onChange={handleInputChange}
                                                className="text-blue-600 focus:ring-blue-500"
                                            />
                                            <span className="text-xs text-slate-700 dark:text-slate-300 capitalize">
                                                {opt.label}
                                            </span>
                                        </label>
                                    ))}
                                </div>
                                <label className="flex items-center gap-1.5 cursor-pointer">
                                    <input
                                        type="checkbox"
                                        name="slac"
                                        checked={formData.slac}
                                        onChange={handleInputChange}
                                        className="rounded border-slate-300 text-blue-600 focus:ring-blue-500"
                                        data-testid="checkbox-slac"
                                    />
                                    <span className="text-xs font-medium text-slate-700 dark:text-slate-300">SLAC</span>
                                </label>
                                <label className="flex items-center gap-1.5 cursor-pointer">
                                    <input
                                        type="checkbox"
                                        name="doNotAutoCalculate"
                                        checked={formData.doNotAutoCalculate}
                                        onChange={handleInputChange}
                                        className="rounded border-slate-300 text-blue-600 focus:ring-blue-500"
                                        data-testid="checkbox-no-auto-calc"
                                    />
                                    <span className="text-xs text-slate-700 dark:text-slate-300">Do not auto calculate</span>
                                </label>
                            </div>

                            {/* Container Table */}
                            <div className="overflow-x-auto">
                                <table className="w-full text-xs" data-testid="particulars-table">
                                    <thead>
                                        <tr className="bg-emerald-600 text-white">
                                            <th className="px-2 py-2 text-left font-medium whitespace-nowrap">CONTAINER</th>
                                            <th className="px-2 py-2 text-left font-medium whitespace-nowrap">CONT. TYPE</th>
                                            <th className="px-2 py-2 text-left font-medium whitespace-nowrap">NO. OF PKG</th>
                                            <th className="px-2 py-2 text-left font-medium whitespace-nowrap">CARGO DESCRIPTION</th>
                                            <th className="px-2 py-2 text-left font-medium whitespace-nowrap">IT #</th>
                                            <th className="px-2 py-2 text-left font-medium whitespace-nowrap">CN/CPRS #</th>
                                            <th className="px-2 py-2 text-left font-medium whitespace-nowrap">PICKUP #</th>
                                            <th className="px-2 py-2 text-left font-medium whitespace-nowrap">LAST FREE DAY</th>
                                            <th className="px-2 py-2 text-left font-medium whitespace-nowrap">NET WEIGHT</th>
                                            <th className="px-2 py-2 text-left font-medium whitespace-nowrap">GROSS WEIGHT</th>
                                            <th className="px-2 py-2 text-left font-medium whitespace-nowrap">MEASUREMENT</th>
                                            <th className="px-2 py-2 text-center font-medium w-10">DEL</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {containers.map((container, index) => {
                                            if (container.isDeleted) return null;
                                            return (
                                                <tr key={container?.id} className="border-t border-slate-100 dark:border-slate-700 align-top">
                                                    {/* Container No / Seal No / Marks No */}
                                                    <td className="px-2 py-2">
                                                        <div className="space-y-1">
                                                            <input
                                                                type="text"
                                                                placeholder="Container No."
                                                                value={container.containerNumber}
                                                                onChange={(e) => handleContainerChange(index, 'containerNumber', e.target.value)}
                                                                className={`${inputClass} py-1.5 text-xs`}
                                                                data-testid={`container-no-${index}`}
                                                            />
                                                            <input
                                                                type="text"
                                                                placeholder="Seal No"
                                                                value={container?.sealNumber}
                                                                onChange={(e) => handleContainerChange(index, 'sealNumber', e.target.value)}
                                                                className={`${inputClass} py-1.5 text-xs`}
                                                            />
                                                            <textarea
                                                                placeholder="Marks No"
                                                                value={container?.marksNo}
                                                                onChange={(e) => handleContainerChange(index, 'marksNo', e.target.value)}
                                                                rows={2}
                                                                className={`${inputClass} py-1.5 text-xs resize-none`}
                                                            />
                                                        </div>
                                                    </td>

                                                    {/* Cont. Type */}
                                                    <td className="px-2 py-2">
                                                        <select
                                                            value={container?.contTypeCode || ''}
                                                            onChange={(e) => {
                                                                handleContainerChange(index, 'contTypeCode', e.target.value)
                                                                handleContainerChange(index, 'contTypeName', e.target.options[e.target.selectedIndex].text)
                                                            }}
                                                            className={`${selectClass} py-1.5 text-xs`}
                                                            data-testid={`cont-type-code-${index}`}
                                                        >
                                                            <option value="">Select</option>
                                                            {
                                                                containerTypeList?.map((container, key) => (
                                                                    <option key={key} value={container.moveTypeId}>{container.moveType}</option>
                                                                ))
                                                            }
                                                        </select>
                                                    </td>

                                                    {/* No of Pkg */}
                                                    <td className="px-2 py-2">
                                                        <input
                                                            type="text"
                                                            value={container.noPackage}
                                                            onChange={(e) => handleContainerChange(index, 'noPackage', e.target.value)}
                                                            className={`${inputClass} py-1.5 text-xs w-16`}
                                                        />
                                                        <select className={`${selectClass} py-1.5 text-xs mt-1`}
                                                            value={container?.packageCode}
                                                            onChange={(e) => handleContainerChange(index, 'packageCode', e.target.value)}
                                                            data-testid={`package-code-${index}`}

                                                        >
                                                            <option value="">SELECT</option>
                                                            <option value="CTNS">CTNS</option>
                                                            <option value="PKGS">PKGS</option>
                                                            <option value="PCS">PCS</option>
                                                            <option value="PLTS">PLTS</option>
                                                        </select>
                                                    </td>

                                                    {/* Cargo Description */}
                                                    <td className="px-2 py-2">
                                                        <textarea
                                                            value={container?.packageDescription}
                                                            onChange={(e) => handleContainerChange(index, 'packageDescription', e.target.value)}
                                                            rows={4}
                                                            className={`${inputClass} py-1.5 text-xs resize-none min-w-[140px]`}
                                                        />
                                                    </td>

                                                    {/* IT # */}
                                                    <td className="px-2 py-2">
                                                        <input
                                                            type="text"
                                                            placeholder="IT No."
                                                            value={container?.itNumber}
                                                            onChange={(e) => handleContainerChange(index, 'itNumber', e.target.value)}
                                                            className={`${inputClass} py-1.5 text-xs`}
                                                        />
                                                    </td>

                                                    {/* CN/CPRS # */}
                                                    <td className="px-2 py-2">
                                                        <input
                                                            type="text"
                                                            placeholder="CN/CPRS #"
                                                            value={container?.cncprsNumber}
                                                            onChange={(e) => handleContainerChange(index, 'cncprsNumber', e.target.value)}
                                                            className={`${inputClass} py-1.5 text-xs`}
                                                        />
                                                    </td>

                                                    {/* Pickup # */}
                                                    <td className="px-2 py-2">
                                                        <input
                                                            type="text"
                                                            placeholder="Pickup No."
                                                            value={container?.pickupNumber}
                                                            onChange={(e) => handleContainerChange(index, 'pickupNumber', e.target.value)}
                                                            className={`${inputClass} py-1.5 text-xs`}
                                                        />
                                                    </td>

                                                    {/* Last Free Day */}
                                                    <td className="px-2 py-2">

                                                        <DateInputwithcal onError={handleDateError} label="Last Free Date" name="lastDate" value={container?.lastDate}
                                                            onChange={(name, value) => handleContainerChange(index, name, value)}
                                                            required />

                                                    </td>

                                                    {/* Net Weight */}
                                                    <td className="px-2 py-2">
                                                        <div className="space-y-1">
                                                            <div className="flex items-center gap-1">
                                                                <span className="text-[10px] text-slate-500 w-10">Net Kgs</span>
                                                                <input type="text" value={container?.netKgs} onChange={(e) => handleContainerChange(index, 'netKgs', e.target.value)} className={`${inputClass} py-1 text-xs w-16`} />
                                                            </div>
                                                            <div className="flex items-center gap-1">
                                                                <span className="text-[10px] text-slate-500 w-10">Net LBS</span>
                                                                <input type="text" value={container?.netLbs} onChange={(e) => handleContainerChange(index, 'netLbs', e.target.value)} className={`${inputClass} py-1 text-xs w-16`} />
                                                            </div>
                                                        </div>
                                                    </td>

                                                    {/* Gross Weight */}
                                                    <td className="px-2 py-2">
                                                        <div className="space-y-1">
                                                            <div className="flex items-center gap-1">
                                                                <span className="text-[10px] text-slate-500 w-6">KGS</span>
                                                                <input type="text" value={container?.kgs} onChange={(e) => handleContainerChange(index, 'kgs', e.target.value)} className={`${inputClass} py-1 text-xs w-16`} />
                                                            </div>
                                                            <div className="flex items-center gap-1">
                                                                <span className="text-[10px] text-slate-500 w-6">LBS</span>
                                                                <input type="text" value={container?.lbs} onChange={(e) => handleContainerChange(index, 'lbs', e.target.value)} className={`${inputClass} py-1 text-xs w-16`} />
                                                            </div>
                                                        </div>
                                                    </td>

                                                    {/* Measurement */}
                                                    <td className="px-2 py-2">
                                                        <div className="space-y-1">
                                                            <div className="flex items-center gap-1">
                                                                <span className="text-[10px] text-slate-500 w-6">CBM</span>
                                                                <input type="text" value={container?.cbm} onChange={(e) => handleContainerChange(index, 'cbm', e.target.value)} className={`${inputClass} py-1 text-xs w-16`} />
                                                            </div>
                                                            <div className="flex items-center gap-1">
                                                                <span className="text-[10px] text-slate-500 w-6">CFT</span>
                                                                <input type="text" value={container?.cft} onChange={(e) => handleContainerChange(index, 'cft', e.target.value)} className={`${inputClass} py-1 text-xs w-16`} />
                                                            </div>
                                                        </div>
                                                    </td>

                                                    {/* Delete */}
                                                    <td className="px-2 py-2 text-center">
                                                        <button
                                                            type="button"
                                                            onClick={() => removeContainer(container)}
                                                            className="p-1.5 text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-md transition-colors"
                                                            // disabled={containers.length === 1}
                                                            data-testid={`delete-row-${index}`}
                                                        >
                                                            <Trash2 className="w-4 h-4" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Add More Row */}
                            <div className="flex justify-center mt-4 mb-4">
                                <button
                                    type="button"
                                    onClick={addContainer}
                                    className="px-5 py-2 bg-emerald-500 hover:bg-emerald-600 text-white rounded-md text-xs font-medium transition-colors flex items-center gap-1.5"
                                    data-testid="add-more-row-btn"
                                >
                                    <Plus className="w-3.5 h-3.5" /> Add More Row
                                </button>
                            </div>

                            {/* Totals */}

                            <div className="bg-gradient-to-br from-slate-50 to-white dark:from-slate-800/50 dark:to-slate-900 rounded-xl border border-slate-200 dark:border-slate-700 p-4">
                                <div className="flex items-center gap-2 mb-4">
                                    <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-indigo-500 to-purple-500 flex items-center justify-center">
                                        <Weight className="w-4 h-4 text-white" />
                                    </div>
                                    <h4 className="text-sm font-semibold text-slate-700 dark:text-slate-200">Total Summary</h4>
                                </div>

                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                                    <div className="bg-white dark:bg-slate-800 rounded-lg p-3 border border-slate-100 dark:border-slate-700">
                                        <p className="text-[10px] text-slate-400 dark:text-slate-500 uppercase tracking-wide mb-1">Containers</p>
                                        <p className="text-lg font-bold text-slate-800 dark:text-slate-200">{totalContainers}</p>
                                    </div>
                                    <div className="bg-white dark:bg-slate-800 rounded-lg p-3 border border-slate-100 dark:border-slate-700">
                                        <p className="text-[10px] text-slate-400 dark:text-slate-500 uppercase tracking-wide mb-1">Packages</p>
                                        <p className="text-lg font-bold text-slate-800 dark:text-slate-200">{totalPackages || '0'}</p>
                                    </div>
                                    <div className="bg-white dark:bg-slate-800 rounded-lg p-3 border border-slate-100 dark:border-slate-700">
                                        <p className="text-[10px] text-slate-400 dark:text-slate-500 uppercase tracking-wide mb-1">Gross KGS</p>
                                        <p className="text-lg font-bold text-slate-800 dark:text-slate-200">{totalGrossKgs.toFixed(3) || '0.00'}</p>
                                    </div>
                                    <div className="bg-white dark:bg-slate-800 rounded-lg p-3 border border-slate-100 dark:border-slate-700">
                                        <p className="text-[10px] text-slate-400 dark:text-slate-500 uppercase tracking-wide mb-1">Gross LBS</p>
                                        <p className="text-lg font-bold text-slate-800 dark:text-slate-200">{totalGrossLbs.toFixed(3) || '0.00'}</p>
                                    </div>
                                    <div className="bg-white dark:bg-slate-800 rounded-lg p-3 border border-slate-100 dark:border-slate-700">
                                        <p className="text-[10px] text-slate-400 dark:text-slate-500 uppercase tracking-wide mb-1">Net KGS</p>
                                        <p className="text-lg font-bold text-emerald-600 dark:text-emerald-400">{totalNetWeightKgs.toFixed(3) || '0.00'}</p>
                                    </div>
                                    <div className="bg-white dark:bg-slate-800 rounded-lg p-3 border border-slate-100 dark:border-slate-700">
                                        <p className="text-[10px] text-slate-400 dark:text-slate-500 uppercase tracking-wide mb-1">Net LBS</p>
                                        <p className="text-lg font-bold text-emerald-600 dark:text-emerald-400">{totalNetWeightLbs.toFixed(3) || '0.00'}</p>
                                    </div>
                                    <div className="bg-white dark:bg-slate-800 rounded-lg p-3 border border-slate-100 dark:border-slate-700">
                                        <p className="text-[10px] text-slate-400 dark:text-slate-500 uppercase tracking-wide mb-1">CBM</p>
                                        <p className="text-lg font-bold text-blue-600 dark:text-blue-400">{totalCbm.toFixed(3) || '0.00'}</p>
                                    </div>
                                    <div className="bg-white dark:bg-slate-800 rounded-lg p-3 border border-slate-100 dark:border-slate-700">
                                        <p className="text-[10px] text-slate-400 dark:text-slate-500 uppercase tracking-wide mb-1">CFT</p>
                                        <p className="text-lg font-bold text-blue-600 dark:text-blue-400">{totalCft.toFixed(3) || '0.00'}</p>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    )}
                </div>

                {/* Save / Update Button */}
                <div className="p-3 bg-white dark:bg-slate-900 rounded-xl shadow-sm border border-gray-200 dark:border-slate-800 flex items-center justify-between">

                    {/* Left side info */}
                    <div className="text-xs text-slate-500 dark:text-slate-400">
                        <span className="text-red-500">*</span> Required fields must be filled
                    </div>

                    {/* Right side actions */}
                    <div className="flex items-center gap-2">

                        {/* Cancel */}
                        <button
                            type="button"
                            onClick={() => navigate("/import-booking")}
                            className="inline-flex items-center gap-1.5 px-4 h-[38px] text-xs font-medium rounded-md text-slate-600 hover:bg-red-50 transition-all"
                        >
                            <X className="w-4 h-4" />
                            <span className="hidden sm:inline">Cancel</span>
                        </button>

                        {/* Divider */}
                        <div className="w-px h-5 bg-slate-200 dark:bg-slate-700" />
                        {Number(formData?.bolId) > 0 && (
                            <button
                                type="button"
                                onClick={() =>
                                    window.open(
                                        `/release-order/print/${btoa(formData?.bolId)}?fileRefNumber=${fileRefNumber}`,
                                        "_blank",
                                        "noopener,noreferrer"
                                    )
                                }
                                className="inline-flex items-center gap-1.5 px-4 h-[38px] text-xs font-medium rounded-md bg-slate-100 text-slate-600 border border-slate-200 hover:bg-slate-200 dark:bg-slate-700 dark:text-slate-200 dark:border-slate-600 dark:hover:bg-slate-600 transition-all"
                            >
                                <Printer className="w-4 h-4" />
                                <span className="hidden sm:inline">Print</span>
                            </button>
                        )}
                        {/* Save / Update */}
                        <button
                            type="button"
                            onClick={handleSubmit}
                            className="inline-flex items-center gap-1.5 px-5 h-[38px] text-xs font-semibold rounded-md bg-emerald-500 text-white hover:bg-emerald-600 transition-all shadow-sm hover:shadow-md"
                            data-testid="save-update-btn"
                        >
                            <Save className="w-4 h-4" />
                            <span>Save / Update</span>
                        </button>

                    </div>
                </div>
            </form >
        </div >
    );
};

export default ReleaseOrderForm;
